import api from './axios';

export const listar = (limit = 500, skip = 0) => api.get('/auditoria/', { params: { limit, skip } });

export const obterEstatisticas = (dias = 30) => api.get('/auditoria/estatisticas', { params: { dias } });
